import { createStateSelectorHook } from 'src/lib/sweetState';
import { NotificationStore } from 'src/store';

export default createStateSelectorHook(NotificationStore, ['upgradeAvailable']);
